import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {RegistriesService} from '../../service';
import {TableReactiveUrlController} from '@amlCore/tableReactive';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertPanelComponent, AlertService} from '@amlCore/components';
import {DictInfo} from '../../model';
import {AccessJson} from '@amlCore/models';
import {CheckDictEnum, RegistriesAccessEnum} from '@amlCore/enums';
import {Utils} from '@amlCore/utils';
import {
  ResourceService,
  TableService,
  UserService,
  VisitedService
} from '@amlCore/services';


@Component({
  selector: 'app-registry-fts-info',
  templateUrl: './ftsInfo.component.html'
})
export class FtsInfoComponent extends TableReactiveUrlController implements OnInit, OnDestroy {

  isShowVisited = true;
  loadCheckList = {};
  placeholder = 'Поиск по ФИО, наименованию, ИНН';
  @ViewChild('alertObjCheck', {static: false}) alertObjToCheck: AlertPanelComponent;

  constructor(private regSrv: RegistriesService,
              private resourceSrv: ResourceService,
              private userSrv: UserService,
              private alertSrv: AlertService,
              protected activatedRoute: ActivatedRoute,
              protected visitedService: VisitedService,
              protected tableService: TableService,
              protected router: Router) {
    super(router, activatedRoute, visitedService, tableService, {pageSize: 20, sort: 'uploaded', dir: 'DESC'});
  }

  public ftsInfoEntries: Array<DictInfo> = [];
  access: AccessJson;

  ngOnInit() {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_MSLEAD);
    localStorage.removeItem('ftsSearch');
    this.activatedRoute.queryParams.subscribe(data => {
      this.loadList(this.syncParams(data));
    });
  }

  onPageChange(params) {
    this.navigate(this.getParams(params));
  }

  loadList(params?: any) {
    const queryParams = this.getParams(params);
    this.resourceSrv.getFtsInfo(queryParams).subscribe(data => {
      this.ftsInfoEntries = data.content;
      this.total = data.totalElements;
      this.scrollRun();
    });
  }

  edit(fts: DictInfo) {
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(['registries/ftsSubject', fts.id]);
  }

  onSearch() {
    const params = this.getSearchPage(this.filter);
    const queryParams = this.getFilterObject(params);
    queryParams["sort"] = "name";
    queryParams["dir"] = "ASC";
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(['registries/ftsInfoAll'], {
      queryParams: {q: Utils.encodeJSONBase64(queryParams)} as Params
    });
  }

  remove(confirm, fts: DictInfo) {
    this.alertSrv.clear();
    this.regSrv.removeFile('/api/v1/qref/fts/remove', {id: fts.id}).subscribe(data => {
      this.alertSrv.success(`Запись ${fts.name} удалена!`);
      this.loadList();
    });
  }

  /**
   * Проверка по факторам риска
   * @param item - элемент проверки
   */
  checkRiskFactor(item: DictInfo) {
    this.regSrv.doCheckRiskFactor(item, CheckDictEnum.FTS, this.loadCheckList, this.alertObjToCheck);
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data) {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  ngOnDestroy() {
    this.checkScrollOptions();
  }

}
